export function decode(token) {
    if (!token || token.split('.').length < 2) {
        throw new Error('Invalid token');
    }

    let base64Url = token.split('.')[1];
    let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');

    while (base64.length % 4) {
        base64 += '=';
    }

    return JSON.parse(window.atob(base64));
}